document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.bn-countries-picker__select').forEach((select) => {
		const section = select.closest('.bn-section');

		const apply = (updateMap) => {
			const option = select.selectedOptions[0];

			if (!option || !section) {
				return;
			}

			if (updateMap) {
				section.querySelectorAll('.bn-countries-map__country.is-active').forEach((group) => {
					group.classList.remove('is-active');
				});

				const country = section.querySelector(
					`.bn-countries-map__country[data-country="${option.dataset.country}"]`
				);

				if (country) {
					country.classList.add('is-active');
				}
			}

			section.querySelectorAll('a[class*="bn-button"]').forEach((button) => {
				button.href = option.value;
			});
		};

		select.addEventListener('change', () => apply(true));
		apply(false);
	});
});
